import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as WarningCircle } from 'assets/svg/icon-warning-circle.svg'

function IconWarningCircle(props: IconProps): JSX.Element {
  const title = 'icon-warning-circle'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <WarningCircle {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconWarningCircle
